var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReschedule({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49885",
    "data-name": "Group 49885",
    transform: "translate(-3715 -4299)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93730",
    "data-name": "Path 93730",
    d: "M7.114,17.114H4.387A3.636,3.636,0,0,1,.75,13.478V4.387A3.637,3.637,0,0,1,4.387.75h10a3.636,3.636,0,0,1,3.636,3.637V7.114",
    transform: "translate(3715 4299)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93731",
    "data-name": "Path 93731",
    d: "M20.75,15.3A5.455,5.455,0,1,1,15.3,9.84,5.455,5.455,0,0,1,20.75,15.3Z",
    transform: "translate(3715 4299)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_614",
    "data-name": "Line 614",
    x2: 16.364,
    transform: "translate(3715.75 4304.295)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_615",
    "data-name": "Line 615",
    y2: 1.818,
    transform: "translate(3730.295 4312.478)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_616",
    "data-name": "Line 616",
    x1: 1.818,
    y1: 1.818,
    transform: "translate(3730.296 4314.295)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReschedule);
export default __webpack_public_path__ + "static/media/Reschedule.e422c254d85618dad7a1efec7d017786.svg";
export { ForwardRef as ReactComponent };